import { BcModel } from './bc.model';
import { BpLineModel } from '../bp/bp-line.model';
import { SocieteLinkedModel } from '../societe-linked.model';
import { NTHDestination, NTHFlag } from 'src/app/shared/constants/flag';
import { LivraisonBcModel } from './livraison-bc.model';

export class BcLineModel extends SocieteLinkedModel {

    code: string = '*';
    libelle: string = '';
    idBc: number = -1;
    bc: BcModel;
    // codeLib Article
    codeArticle: string = '';
    libelleArticle: string = '';
    // codeLib TVA
    codeTva: string = '';
    libelleTva: string = '';
    // Taux TVA: string
    tauxTva: number = 0;
    // codeLib CA1
    codeCa1: string = '';
    libelleCa1: string = '';
    // codeLib NA
    codeNa: string = '';
    libelleNa: string = '';
    // codeLib CG Charge
    codeCgCharge: string = '';
    libelleCgCharge: string = '';
    // codeLib CA2
    codeCa2: string = '';
    libelleCa2: string = '';
    // code Chantier ( ancien code ae)
    chantier: string = '';
    // codeLib Complement
    codeComp: string = '';
    libelleComp: string = '';
    // Equipement | N° de parc
    vehicule: string = '';

    // Dates
    dAnnule: Date;
    dProvis: Date;
    dDeprovis: Date;
    dLivraison: Date = new Date(Date.now());

    // QTE obligatoire
    qte: number = 1;
    // QTE Restante
    qteRestant: number = 0;
    // QTE Annule
    qteAnnule: number = 0;
    // Qte livré
    qteLivre: number = 0;
    // Qte déprovisionné
    qteDprovis: number = 0;
    // prix unitaire
    pu: number = 0;
    // Montant hors taxe (obligatoire)
    ht: number = 0;
    // Montant hors taxe Restant (obligatoire)
    htRestant: number = 0;
    // Montant TTC
    ttc: number = 0;
    /**
     *  @description position de la ligne dans le tableau
     */
    position: number = 0;
    // Flags
    fFacture: NTHFlag = NTHFlag.None;
    fLivre: NTHFlag = NTHFlag.None;
    fHasbp: NTHFlag = NTHFlag.None;

    // Booleans
    bAnnule: boolean = false;
    fProvis: NTHFlag = NTHFlag.None;
    fDeprovis: NTHFlag = NTHFlag.None;

    // Liste des bp lignes
    bpLines: BpLineModel[] = [];

    livraisonsBc: LivraisonBcModel[] = [];

    codeCategorie: string = '';

    destination? : NTHDestination;
       
    codeFamille: string
    libelleFamille: string  
    codeSsFamille: string
    libelleSsFamille: string

    fLitige: NTHFlag = NTHFlag.None;
}
